/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step away from the screen — stand up, stretch, get water, or look out a window. The point is to rest attention, not switch to another screen-based task like checking email, which keeps the same mental load active.`)
};

const es_timer_pomodoro_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aléjate de la pantalla — ponte de pie, estírate, toma agua o mira por una ventana. La idea es descansar la atención, no cambiar a otra tarea frente a una pantalla como revisar el correo, que mantiene activa la misma carga mental.`)
};

const de_timer_pomodoro_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geh weg vom Bildschirm — steh auf, streck dich, trink Wasser oder schau aus dem Fenster. Es geht darum, die Aufmerksamkeit zu erholen, nicht zu einer anderen bildschirmbasierten Aufgabe wie E-Mails zu wechseln, die dieselbe mentale Belastung aufrechterhält.`)
};

const nl_timer_pomodoro_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loop weg van het scherm — sta op, rek je uit, drink water of kijk uit het raam. Het punt is om je aandacht te laten rusten, niet om over te schakelen naar een andere schermtaak zoals e-mail checken, want dat houdt dezelfde mentale belasting actief.`)
};

const fr_timer_pomodoro_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éloignez-vous de l’écran — levez-vous, étirez-vous, buvez de l’eau ou regardez par la fenêtre. Le but est de reposer votre attention, pas de passer à une autre tâche sur écran comme consulter vos e-mails, ce qui maintient la même charge mentale active.`)
};

const it_timer_pomodoro_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allontanati dallo schermo — alzati, stiracchia, bevi acqua o guarda fuori dalla finestra. L'obiettivo è far riposare l'attenzione, non passare a un'altra attività davanti allo schermo come controllare le email, che mantiene attivo lo stesso carico mentale.`)
};

const pt_br2_timer_pomodoro_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afaste-se da tela — levante-se, alongue-se, beba água ou olhe pela janela. O objetivo é descansar a atenção, não trocar para outra tarefa baseada em tela, como checar e-mails, o que mantém a mesma carga mental ativa.`)
};

const pt_timer_pomodoro_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afaste-se do ecrã — levante-se, alongue-se, beba água ou olhe pela janela. O objetivo é descansar a atenção, não mudar para outra tarefa no ecrã, como verificar o e-mail, o que mantém ativa a mesma carga mental.`)
};

const ja_timer_pomodoro_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面から離れましょう — 立ち上がる、ストレッチする、水を飲む、窓の外を見るなど。大切なのは注意力を休ませることであり、メールチェックのような別の画面作業に切り替えることではありません。それでは同じ精神的な負荷がかかったままになります。`)
};

const zh_timer_pomodoro_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离开屏幕 — 站起来、伸展身体、喝水，或看看窗外。重点是让注意力得到休息，而不是切换到另一项同样用屏幕的任务，比如查看邮件，那样精神负荷仍然持续。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_faq3_a", locale)
	if (locale === "en") return en_timer_pomodoro_faq3_a(inputs)
	if (locale === "es") return es_timer_pomodoro_faq3_a(inputs)
	if (locale === "de") return de_timer_pomodoro_faq3_a(inputs)
	if (locale === "nl") return nl_timer_pomodoro_faq3_a(inputs)
	if (locale === "fr") return fr_timer_pomodoro_faq3_a(inputs)
	if (locale === "it") return it_timer_pomodoro_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_faq3_a(inputs)
	if (locale === "pt") return pt_timer_pomodoro_faq3_a(inputs)
	if (locale === "ja") return ja_timer_pomodoro_faq3_a(inputs)
	return zh_timer_pomodoro_faq3_a(inputs)
};